import MedicineSettingsChat from "./MedicineSettingsChat";

export default MedicineSettingsChat;